import script from "./CallsHistoryTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CallsHistoryTable.vue?vue&type=script&setup=true&lang=js"

import "./CallsHistoryTable.vue?vue&type=style&index=0&id=cb5688f2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb5688f2"]])

export default __exports__